<!--
	作者：masonchen
	时间：2017-04-10
	描述：轨迹回放页面
-->
<template>
	<!--车辆监控页面_右侧tab面板之标注列表开始-->
	<div class="tab-bar">
		<div class="tab-row">
		  <div class="car_fence ">
			<ul>
				<li v-for="(note,index) in noteArr">
					<dl>
						<dt><span>{{note.areaName}}</span><a  class="ico_close"  @click="deleteMarker(note.iD)"></a></dt>						
						<dd><i><a class="ico_01a"  @click="addToMap(index,note.iD,note.pOINTS)">{{note.showFlag?'显示':'隐藏'}}</a></i></dd>
						<p>{{note.address}}</p>
			        </dl>
				</li>		
			</ul>
			<laypage ref="mkLay" :pages="pagesTotal" v-on:changePage="cb" :groups="pagesTotal > 3 ? 3 : pagesTotal" :first="first" :last="last" :prev="prev" :next="next" class="laypage"></laypage>
		  </div>	
		  <div class="track_bottom_btn03">
			  <i>共有{{noteTotal}}个标注</i>
		  </div>
		</div>
	</div>
	<!--车辆监控页面_右侧tab面板之标注列表结束-->
</template>
<script>
	import {setSessionStore,getSessionStore} from 'util/util'
	import {mapState} from 'vuex'
	import Laypage from 'components/common/vueLaypage/Laypage'
	export default {
		name: 'MarkersList',
		components:{
			Laypage
		},
		data() {
			return {
				firstOpen:true,
				noteTotal:0,
				noteArr:[],
				pagesTotal:0, //总页数
		        first:false, //不显示首页
		        last:false,	//不显示尾页
		        prev: '上一页',
		        next: '下一页'
				
			}
		},
		computed: mapState({
			areaType:state=>state.monitor.areaType,
			areaInfo:state=>state.monitor.areaInfo,
			groupId:state=>state.user.groupid
		}),
		watch:{
			areaInfo:function(val){
			 	if(this.areaType==3){
			 		this.noteTotal = val.list.length;
			 		this.pagesTotal = val.pages;
			 		this.$nextTick(function(){
						this.$refs.mkLay.setPage(val.pageNum)
					})
					this.noteArr = val.list;
					if(!this.firstOpen){
						let arr = getSessionStore('noteArr')
						let curNote = JSON.parse(arr)
						for(let i = 0,length = this.noteArr.length; i < length; i ++){
							let index = curNote.findIndex(n=>n.iD==this.noteArr[i].iD)
							if(index!=-1){
								this.noteArr[i].showFlag=curNote[index].showFlag
								this.noteArr[i].clickCount=curNote[index].clickCount
							}else{
								this.noteArr[i].showFlag = true;
								this.noteArr[i].clickCount = 0;
							}
						}
					}else{
						this.initList()
					}
					const that = this
					setSessionStore('noteArr',that.noteArr)
			 	}
			}
		},
		destroyed(){
			this.initList()
		},
		methods: {
			initList(){
				this.firstOpen = false
				for(let i = 0,length = this.noteArr.length; i < length; i ++){
						this.noteArr[i].showFlag = true;
						this.noteArr[i].clickCount = 0;
						this.noteArr.splice(i,1,this.noteArr[i])
				}
				const that = this
				setSessionStore('noteArr',that.noteArr)
			},
			cb(page) {//分页组件回调
		        this.page = page
		        const param = {
		        	page_index:page,
					areaType:3,
					customerId:this.groupId
		        }
		        this.$store.dispatch('getAreaList',param)
		   	},
			addToMap(index,id,points){
				this.noteArr[index].clickCount ++;
				this.noteArr.splice(index,1,this.noteArr[index])
				if(this.noteArr[index].clickCount%2==0){//隐藏
					this.noteArr[index].showFlag = true;
					this.noteArr.splice(index,1,this.noteArr[index])
					this.$store.dispatch('removeMarker',id)
				}else{//显示
					this.noteArr[index].showFlag = false;
					this.noteArr.splice(index,1,this.noteArr[index])
					const obj = {
						id:id,
						point:JSON.parse(points)[0]
					}
					this.$store.dispatch('addressToPoint',obj)
				}
				const that = this
				setSessionStore('noteArr',that.noteArr)
			},
			deleteMarker(id){
				const obj = {
					id:id,
					type:'标注',
					areaType:3,
					delType:'marker'
				}
				this.$store.dispatch('deleteModalShow',obj)
			}

		}

	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// MarkersList.vue?4c08e6f5